import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Shield, Users, PawPrint, Package, BarChart3 } from 'lucide-react';

export function Admin() {
    const { isAuthenticated, isRoot, user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/login', { replace: true });
            return;
        }
        if (!isRoot) {
            navigate(`/consultas/${user?.id || ''}`, { replace: true });
        }
    }, [isAuthenticated, isRoot, user, navigate]);

    if (!isRoot) return null;

    const stats = [
        { label: 'Usuarios', value: '—', icon: Users, color: 'from-sp-primary to-sp-accent' },
        { label: 'Mascotas', value: '—', icon: PawPrint, color: 'from-sp-accent to-sp-pink' },
        { label: 'Productos', value: '—', icon: Package, color: 'from-sp-cta to-green-400' },
        { label: 'Scans hoy', value: '—', icon: BarChart3, color: 'from-orange-400 to-yellow-400' },
    ];

    return (
        <main className="min-h-screen bg-sp-light">
            <section className="bg-gradient-to-br from-sp-dark to-sp-primary pt-6 pb-10 px-4 xs:px-5">
                <div className="max-w-[1100px] mx-auto">
                    <div className="flex items-center gap-3 mb-2">
                        <Shield className="w-6 h-6 text-sp-pink" />
                        <span className="text-white/70 text-[0.75rem] font-bold uppercase tracking-wider">
                            Panel de administración
                        </span>
                    </div>
                    <h1 className="text-white text-[1.3rem] xs:text-[1.5rem] font-black">
                        Dashboard Root
                    </h1>
                </div>
            </section>

            <section className="max-w-[1100px] mx-auto px-4 xs:px-5 py-6 xs:py-8">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 xs:gap-4">
                    {stats.map((stat, i) => (
                        <div
                            key={i}
                            className="bg-white rounded-2xl p-4 xs:p-5 shadow-sp hover:shadow-sp-hover transition-all"
                        >
                            <div className={`w-10 h-10 xs:w-12 xs:h-12 rounded-xl bg-gradient-to-br ${stat.color} flex items-center justify-center mb-3`}>
                                <stat.icon className="w-5 h-5 xs:w-6 xs:h-6 text-white" />
                            </div>
                            <p className="text-sp-text font-black text-xl xs:text-2xl">{stat.value}</p>
                            <p className="text-sp-muted text-[0.75rem] xs:text-[0.8rem] font-bold uppercase tracking-wide">
                                {stat.label}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="mt-6 xs:mt-8 bg-white rounded-2xl xs:rounded-3xl p-5 xs:p-8 shadow-sp">
                    <h2 className="text-sp-text font-black text-[1.1rem] xs:text-[1.2rem] mb-4">
                        Acciones rápidas
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 xs:gap-4">
                        <button className="h-12 xs:h-14 bg-sp-primary text-white rounded-xl font-extrabold text-[0.9rem] hover:bg-sp-dark transition-colors">
                            Gestionar usuarios
                        </button>
                        <button className="h-12 xs:h-14 bg-sp-accent text-white rounded-xl font-extrabold text-[0.9rem] hover:opacity-90 transition-opacity">
                            Gestionar productos
                        </button>
                        <button className="h-12 xs:h-14 bg-sp-cta text-white rounded-xl font-extrabold text-[0.9rem] hover:bg-sp-cta-hover transition-colors">
                            Ver códigos QR
                        </button>
                        <button className="h-12 xs:h-14 bg-sp-label text-sp-primary rounded-xl font-extrabold text-[0.9rem] hover:bg-sp-surface transition-colors">
                            Reportes
                        </button>
                    </div>
                </div>
            </section>
        </main>
    );
}